/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.posiblePositions = exports.default = void 0;
var positionMap = {
  top: {
    alias: 'top',
    position: 'bc-tc',
    offset: {
      x: 1,
      y: -1,
      resetNumeric: 'x'
    }
  },
  'bc-tc': {
    alias: 'top',
    position: 'bc-tc',
    offset: {
      x: 1,
      y: -1,
      resetNumeric: 'x'
    }
  },
  'bl-tl': {
    alias: 'topAlignedLeft',
    position: 'bl-tl',
    offset: {
      x: 1,
      y: -1,
      resetNumeric: 'x'
    }
  },
  'br-tr': {
    alias: 'topAlignedRight',
    position: 'br-tr',
    offset: {
      x: 1,
      y: -1,
      resetNumeric: 'x'
    }
  },
  'br-tl': {
    alias: 'topLeft',
    position: 'br-tl',
    offset: {
      x: -1,
      y: -1
    }
  },
  right: {
    position: 'lc-rc',
    alias: 'right',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'lc-rc': {
    position: 'lc-rc',
    alias: 'right',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'tl-tr': {
    position: 'tl-tr',
    alias: 'rightAlignedTop',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'bl-br': {
    position: 'bl-br',
    alias: 'rightAlignedBottom',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'tl-br': {
    position: 'tl-br',
    alias: 'bottomRight',
    offset: {
      x: 1,
      y: 1
    }
  },
  bottom: {
    position: 'tc-bc',
    alias: 'bottom',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'x'
    }
  },
  'tc-bc': {
    position: 'tc-bc',
    alias: 'bottom',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'x'
    }
  },
  'tl-bl': {
    position: 'tl-bl',
    alias: 'bottomAlinedLeft',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'x'
    }
  },
  'tr-br': {
    position: 'tr-br',
    alias: 'bottomAlignedRight',
    offset: {
      x: 1,
      y: 1,
      resetNumeric: 'x'
    }
  },
  'tr-tr': {
    position: 'tr-tr',
    offset: {
      x: 1,
      y: -1
    }
  },
  'tr-bl': {
    position: 'tr-bl',
    alias: 'bottomLeft',
    offset: {
      x: -1,
      y: 1
    }
  },
  left: {
    position: 'rc-lc',
    alias: 'left',
    offset: {
      x: -1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'rc-lc': {
    position: 'rc-lc',
    alias: 'left',
    offset: {
      x: -1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'tr-tl': {
    position: 'tr-tl',
    alias: 'leftAlignedTop',
    offset: {
      x: -1,
      y: 1,
      resetNumeric: 'y'
    }
  },
  'br-bl': {
    position: 'br-bl',
    alias: 'leftAlignedBottom',
    offset: {
      x: -1,
      y: 1,
      resetNumeric: 'y'
    }
  }
};
var posiblePositions = Object.keys(positionMap);
exports.posiblePositions = posiblePositions;
var _default = positionMap;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/getPositionRelativeToElement/positionsMap.js
// module id = 100
// module chunks = 0